import React from 'react'

import { InnerWrapper, StyledContent, Wrapper } from './FileContents.styles'
import { NoContent } from './NoContent'

interface IFrameViewerProps {
  fileExtension: string
  signedUrl?: string
}

export const IFrameViewer = ({ fileExtension, signedUrl }: IFrameViewerProps) => {
  if (!signedUrl) return <NoContent />

  return (
    <Wrapper>
      <InnerWrapper>
        <StyledContent>
          <iframe
            title={`${fileExtension}FilePreview`}
            src={signedUrl}
            width="100%"
            data-testid={`${fileExtension}-file-preview`}
          />
        </StyledContent>
      </InnerWrapper>
    </Wrapper>
  )
}
